import { render, staticRenderFns } from "./VOption.vue?vue&type=template&id=1903365b&scoped=true"
import script from "./VOption.ts?vue&type=script&lang=ts&external"
export * from "./VOption.ts?vue&type=script&lang=ts&external"
import style0 from "./VOption.vue?vue&type=style&index=0&id=1903365b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1903365b",
  null
  
)

export default component.exports